import { DataSource, Layout, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDistanceRouteDetails extends Layout {
    sourceInStateDistance: DataSource;
    sourceRouteDetails: DataSource;
    sourceRoutes: DataSource;
    tabInStateDistances: Tab;
    tabRouteDetails: Tab;
    tableInStateDistances: Table;
    tableRoutes: Table;
    tabsetRouteReports: Tabset;
}
